'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCloudDownload = function IoIosCloudDownload(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.9 34v-8.4h1.2v8.4l4.3-4.2 1 0.9-5.9 5.7-5.8-5.7 0.9-0.9z m11.8-21.2c3.5 0 6.3 2.9 6.3 6.4s-2.9 6.4-6.4 6.4h-10.5v-10.5h-1.2v10.5h-9.9c-3.9 0-7-3.1-7-6.9 0-3.1 2-5.6 4.8-6.5 0.4-2.2 2.2-4 4.6-4 0.8 0 1.4 0.2 2 0.5 1.5-3.1 4.6-5.1 8.2-5.1 5 0 9.1 4 9.1 9 0 0.1 0 0.1 0 0.2z' })
        )
    );
};

exports.default = IoIosCloudDownload;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-cloud-download.js
// module id = 2602
// module chunks = 168707334958949